<template>
  <div class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">{{ empresa.id ? 'Dados da Empresa' : 'Configuração da Empresa' }}</h4>
      <button
        type="button"
        class="btn btn-secondary btn-sm me-3"
        @click="voltar"
      >
        Voltar
      </button>
    </div>

    <div v-if="isSuperAdmin" class="mx-auto mb-3 text-start" style="width: 250px;">
      <SelectField
        v-model="empresa.plano_sistema"
        label="Plano Contratado do Sistema"
        id="plano_sistema"
        :options="[
          { value: 'STANDARD', text: 'Essencial' },
          { value: 'PREMIUM', text: 'Performance' }
        ]"
      />
      <small class="text-muted">Configuração restrita ao Super Administrador.</small>
    </div>


    <div class="empresa-secoes">
    <BoletosModuloControl :pode-alterar-modulo="podeAlterarModulo" />

    <BaseForm
      :isFormValid="isFormValid"
      :isSubmitting="isSubmitting"
      @submit="salvarEmpresa"
      @cancel="cancelarFormulario"
    >

      <!-- Dados da Empresa -->
      <FormSection title="Dados da Empresa">

        <InputField 
          v-model="empresa.razao_social" 
          label="Razão Social <span class='required'>*</span>"
          id="razao_social" 
          placeholder="Digite o nome da Empresa" 
          :class="{ 'error-input': errors.razao_social }"
          width="320px"
          required
        />

        <InputField 
          v-model="empresa.nome_fantasia" 
          label="Nome Fantasia <span class='required'>*</span>" 
          id="nome_fantasia" 
          placeholder="Digite o nome fantasia" 
          width="300px"

          required
        />

        <InputField 
          v-model="empresa.cnpj" 
          label="CNPJ <span class='required'>*</span>" 
          id="cnpj" 
          placeholder="Digite o CNPJ" 
          mask="cnpj" 
          :class="{ 'error-input': errors.cnpj }"
          required
          width="130px"
        />
        <span v-show="errors.cnpj" class="error-message">{{ errors.cnpj }}</span>

        <InputField 
          v-model="empresa.telefone1" 
          label="Telefone" 
          id="telefone1" 
          placeholder="Digite o telefone"
          mask="telefone"
          width="110px"
        />
        <InputField 
          v-model="empresa.telefone2" 
          label="Celular <span class='required'>*</span>" 
          id="telefone2" 
          placeholder="Digite o celular"
          mask="celular"
          width="110px"
        />
        <InputField 
          v-model="empresa.email" 
          label="Email <span class='required'>*</span>" 
          id="email" 
          placeholder="Digite o email"
          :class="{ 'error-input': errors.email }"
          width="250px"
          />

        <InputField 
          v-model="empresa.slogan" 
          label="Slogan" 
          id="slogan" 
          placeholder="Digite o slogan" 
          width="320px"
          required
        />

      </FormSection>

      <!-- Endereço -->
      <FormSection title="Endereço">
        <InputField 
          v-model="empresa.cep" 
          label="CEP <span class='required'>*</span>" 
          id="cep" 
          placeholder="Digite o CEP"
          mask="cep"
          :class="{ 'error-input': errors.cep }"
          width="80px"
        />
        <InputField 
          v-model="empresa.endereco" 
          label="Endereço <span class='required'>*</span>" 
          id="endereco" 
          placeholder="Digite o endereço"
          :class="{ 'error-input': errors.endereco }"
          width="300px"
        />
        <InputField 
          v-model="empresa.numero" 
          label="Número <span class='required'>*</span>" 
          id="numero"
          :class="{ 'error-input': errors.numero }"
          width="50px"
        />
        <InputField 
          v-model="empresa.bairro" 
          label="Bairro <span class='required'>*</span>" 
          id="bairro"
          :class="{ 'error-input': errors.bairro }"
          width="200"
          />
        <InputField 
          v-model="empresa.complemento" 
          label="Complemento" 
          id="complemento"
          width="100px"
          />
        
        <SelectField 
          v-if="estados.length > 0" 
          v-model="empresa.estado_cod" 
          label="Estado <span class='required'>*</span>" 
          id="estado" 
          :options="estados.map(e => ({ value: e.id, text: `${e.nome} (${e.sigla})` }))"
          @change="carregarMunicipios"
          :class="{ 'error-input': errors.estado_cod }"
        />

        <SelectField 
          v-if="municipios.length > 0" 
          v-model="empresa.municipio_cod" 
          label="Município <span class='required'>*</span>" 
          id="municipio" 
          :options="municipios.map(m => ({ value: m.id, text: m.nome }))"
          :class="{ 'error-input': errors.municipio_cod }"
        />

      </FormSection>

      <!-- Redes Sociais -->
      <FormSection title="Redes Sociais">
        <InputField 
          v-model="empresa.site" 
          label="Site" 
          id="site" 
          placeholder="Digite o site"
          width="230px"
        />
        <InputField 
          v-model="empresa.whatsapp_url" 
          label="Whatsapp" 
          id="whatsapp_url" 
          placeholder="Digite o Whatsapp"
          mask="celular"
          width="230px"

        />
        <InputField 
          v-model="empresa.instagram_url" 
          label="Instagram" 
          id="instagram_url" 
          placeholder="Digite o Instagram"
          width="230px"

        />
        <InputField 
          v-model="empresa.facebook_url" 
          label="Facebook" 
          id="facebook_url" 
          placeholder="Digite o Facebook"
          width="230px"

        />
        <InputField 
          v-model="empresa.youtube_url" 
          label="Youtube" 
          id="youtube_url" 
          placeholder="Digite o Youtube"
          width="230px"
        />
        <InputField 
          v-model="empresa.x_url" 
          label="Twitter / X" 
          id="x_url" 
          placeholder="Digite o Twitter / X"
          width="230px"
        />
        <InputField 
          v-model="empresa.linkedin_url" 
          label="LinkedIn" 
          id="linkedin_url" 
          placeholder="Digite o LinkedIn"
          width="230px"
        />
      </FormSection>

      <!-- Arquivos -->
      <FormSection title="Arquivos">
        <div class="d-flex justify-content-between align-items-start flex-wrap"> 
          <!-- Logomarca -->
          <div class="p-2 text-center" style="flex: 1; min-width: 250px;">
            <label for="logomarca" class="form-label">Logomarca</label>
            <input 
              type="file" 
              id="logomarca" 
              class="form-control file-input-small"
              accept="image/png,image/jpeg"
              @change="selecionarArquivo('logomarca', $event)" 
            />
            <span class="form-text text-muted d-block mt-1">
              Imagens PNG ou JPEG. Tamanho máximo: 2 MB.
            </span>

            <img
              v-if="logoSrc"
              :src="logoSrc"
              alt="Logomarca"
              class="img-thumbnail mt-2 img-small"
            />
          </div>

          <!-- Plano de Fundo -->
          <div class="p-2 text-center" style="flex: 1; min-width: 250px;">
            <label for="plano_de_fundo" class="form-label">Plano de Fundo</label>
            <input 
              type="file" 
              id="plano_de_fundo" 
              class="form-control file-input-small"
              accept="image/png,image/jpeg"
              @change="selecionarArquivo('plano_de_fundo', $event)" 
            />
            <span class="form-text text-muted d-block mt-1">
              Imagens PNG ou JPEG. Tamanho máximo: 5 MB.
            </span>

            <img
              v-if="bgSrc"
              :src="bgSrc"
              alt="Plano de Fundo"
              class="img-thumbnail mt-2 img-small"
            />
          </div>

        </div>
      </FormSection>

      <!-- Certificado -->
      <FormSection title="Certificado (Mudança de Nível)">
        <div class="d-flex justify-content-between align-items-start flex-wrap">
          <!-- Modelo do Certificado (upload + preview) -->
          <div class="p-2 text-center" style="flex: 1; min-width: 260px;">
            <label for="certificado_modelo" class="form-label">
              Modelo do Certificado (PNG/JPG) <span class="required">*</span>
            </label>
            <input
              type="file"
              id="certificado_modelo"
              class="form-control file-input-small"
              accept="image/png,image/jpeg"
              @change="selecionarArquivo('certificado_modelo', $event)"
            />
            <img
              v-if="certificadoSrc"
              :src="certificadoSrc"
              alt="Modelo do Certificado"
              class="img-thumbnail mt-2"
              style="max-width: 260px; height: auto;"
            />
            <div class="form-text mt-1">
              Imagens PNG ou JPEG. Tamanho máximo: 8 MB.
              <br />
              Recomendação: A4 300dpi — 3508×2480 (paisagem) / 2480×3508 (retrato)
            </div>
          </div>

          <!-- Configurações gerais -->
          <div class="p-2" style="flex: 1; min-width: 260px;">
            <div class="form-check form-switch mb-2">
              <input class="form-check-input" type="checkbox" id="certificado_ativo"
                    v-model="empresa.certificado_ativo">
              <label class="form-check-label" for="certificado_ativo">Emissão de Certificado Ativa</label>
            </div>

            <InputField
              v-model="empresa.certificado_dpi"
              label="DPI"
              id="certificado_dpi"
              placeholder="300"
              width="80px"
            />

            <div class="mt-2">
              <small class="text-muted">
                Versão do modelo: {{ empresa.certificado_modelo_versao ?? 1 }}
              </small>
            </div>
          </div>

          <!-- Editor simples de Layout -->
          <div class="p-2" style="flex: 1; min-width: 320px;">
            <h6 class="mb-2">Layout: posições & estilos</h6>

            <!-- Nome -->
            <div class="border rounded p-2 mb-2">
              <strong>NOME</strong>
              <div class="d-flex gap-2 flex-wrap">
                <InputField v-model.number="layoutBinding.nome.x" label="x" id="nome_x" width="70px" />
                <InputField v-model.number="layoutBinding.nome.y" label="y" id="nome_y" width="70px" />
                <InputField v-model.number="layoutBinding.nome.w" label="w" id="nome_w" width="70px" />
                <SelectField v-model="layoutBinding.nome.align" label="Alinhamento" id="nome_align"
                  :options="[{value:'left',text:'Esq.'},{value:'center',text:'Centro'},{value:'right',text:'Dir.'}]"
                />
                <InputField v-model.number="layoutBinding.nome.size" label="Tamanho" id="nome_size" width="90px" />
                <InputField v-model="layoutBinding.nome.color" label="Cor" id="nome_color" width="120px" placeholder="#000000" />
              </div>
            </div>

            <!-- Nível -->
            <div class="border rounded p-2 mb-2">
              <strong>NÍVEL</strong>
              <div class="d-flex gap-2 flex-wrap">
                <InputField v-model.number="layoutBinding.nivel.x" label="x" id="nivel_x" width="70px" />
                <InputField v-model.number="layoutBinding.nivel.y" label="y" id="nivel_y" width="70px" />
                <InputField v-model.number="layoutBinding.nivel.w" label="w" id="nivel_w" width="70px" />
                <SelectField v-model="layoutBinding.nivel.align" label="Alinhamento" id="nivel_align"
                  :options="[{value:'left',text:'Esq.'},{value:'center',text:'Centro'},{value:'right',text:'Dir.'}]"
                />
                <InputField v-model.number="layoutBinding.nivel.size" label="Tamanho" id="nivel_size" width="90px" />
                <InputField v-model="layoutBinding.nivel.color" label="Cor" id="nivel_color" width="120px" placeholder="#000000" />
              </div>
            </div>

            <!-- Data -->
            <div class="border rounded p-2">
              <strong>DATA</strong>
              <div class="d-flex gap-2 flex-wrap">
                <InputField v-model.number="layoutBinding.data.x" label="x" id="data_x" width="70px" />
                <InputField v-model.number="layoutBinding.data.y" label="y" id="data_y" width="70px" />
                <InputField v-model.number="layoutBinding.data.w" label="w" id="data_w" width="70px" />
                <SelectField v-model="layoutBinding.data.align" label="Alinhamento" id="data_align"
                  :options="[{value:'left',text:'Esq.'},{value:'center',text:'Centro'},{value:'right',text:'Dir.'}]"
                />
                <InputField v-model.number="layoutBinding.data.size" label="Tamanho" id="data_size" width="90px" />
                <InputField v-model="layoutBinding.data.color" label="Cor" id="data_color" width="120px" placeholder="#000000" />
              </div>
              <small class="text-muted">Formato de data: “Brasília, dd 'de' MMMM 'de' yyyy”</small>
            </div>
          </div>
        </div>

        <!-- Pré-visualização (Canvas) -->
        <div class="mt-3">
          <h6 class="mb-2">Pré-visualização</h6>
          <canvas ref="canvasPreview" class="border rounded w-100" style="max-height: 520px; background: #f8f9fa;"></canvas>
          <div class="form-text">A prévia usa textos fictícios: “ALUNO EXEMPLO”, “NÍVEL II”, “31 de outubro de 2025”.</div>
        </div>
      </FormSection>

    </BaseForm>
    </div>
  </div>
</template>  

<script>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import InputField from '@/components/Layout/InputField.vue';
import SelectField from '@/components/Layout/SelectField.vue';
import FormSection from '@/components/Layout/FormSection.vue';
import BaseForm from '@/components/Layout/BaseForm.vue';
import BoletosModuloControl from './BoletosModuloControl.vue';
import { podeAlterarModuloBoletos } from '@/utils/boletosCapability.mjs';
import axios from '@/services/axios';
import globalUtils from '@/utils/globalUtils.js';
import { getCurrentInstance } from 'vue';

export default {
  components: { InputField, SelectField, FormSection, BaseForm, BoletosModuloControl },
  setup() {
    const router = useRouter();
    const { appContext } = getCurrentInstance();
    const $globalState = appContext?.config?.globalProperties?.$globalState ?? {};

    const isSuperAdmin = computed(() => {
      const perms = Array.isArray($globalState?.userPermissions)
        ? $globalState.userPermissions
        : [];

      return perms.includes('super_administrador');
    });    

    const podeAlterarModulo = computed(() => podeAlterarModuloBoletos($globalState.userPermissions));

    // chave local para cache-busting quando ainda não existe assetsVersion global
    const cacheKey = ref(Date.now());
    // Base da API (funciona no DEV e no proxy): ex. "http://localhost:3001" ou "/api"
    // const API_BASE = (axios.defaults?.baseURL || '').replace(/\/+$/, '');

    const empresa = reactive({
      id: null,
      razao_social: '',
      nome_fantasia: '',
      slogan: '',
      cnpj: '',
      telefone1: '',
      telefone2: '',
      email: '',
      endereco: '',
      numero: '',
      complemento: '',
      bairro: '',
      cep: '',
      estado_cod: null,
      municipio_cod: null,
      site: '',
      whatsapp_url: '',
      instagram_url: '',
      facebook_url: '',
      youtube_url: '',
      x_url: '',
      linkedin_url: '',
      plano_sistema: 'PREMIUM',
      certificado_ativo: true,
      certificado_dpi: 300,
      certificado_modelo_versao: 1,
      certificado_layout: null, // receberá JSON do backend
    });

    const logomarca = ref(null);
    const planoDeFundo = ref(null);
    const certificadoModelo = ref(null);
    const certificadoSrc = computed(() =>
      empresa.certificadoModeloPreview ||
      `${apiUrl('/configuracoes/empresa/certificado-modelo')}?v=${versionParam.value}`
    );
    const estados = ref([]);
    const municipios = ref([]);
    const errors = reactive({});
    const formTouched = ref(false);
    const isSubmitting = ref(false);

    const versionParam = computed(() => String(($globalState?.assetsVersion) || cacheKey.value));

    // Helper para montar URL da API a partir da base do axios (funciona em DEV e via proxy)
    function apiUrl(path) {
      const base = (axios?.defaults?.baseURL || '').replace(/\/+$/, '');
      return `${base}${path}`;
    }

    const logoSrc = computed(() =>
      empresa.logomarcaPreview || `${apiUrl('/configuracoes/empresa/logomarca')}?v=${versionParam.value}`
    );
    const bgSrc = computed(() =>
      empresa.plano_de_fundoPreview || `${apiUrl('/configuracoes/empresa/plano-fundo')}?v=${versionParam.value}`
    );

    // Defaults seguros para o layout (se vier null)
    function defaultLayout() {
      return {
        page: { width_px: 3508, height_px: 2480, orientation: 'landscape' },
        nome:  { x: 2290, y: 1650, w: 1700, align: 'center', font: 'Montserrat-Bold', size: 200, color: '#000000', uppercase: true },
        nivel: { x: 2290, y: 2390, w: 1700, align: 'center', font: 'Montserrat-SemiBold', size: 160, color: '#000000', prefixo: 'NÍVEL ' },
        data:  { x: 2290, y: 3100, w: 1700, align: 'center', font: 'Montserrat-Regular', size: 160, color: '#000000', formato: "Brasília, dd 'de' MMMM 'de' yyyy" }
      };
    }

    // layoutBinding: objeto editável no form; sincronizamos com empresa.certificado_layout no salvar
    const layoutBinding = reactive(defaultLayout());

    const canvasPreview = ref(null);

    function drawPreview() {
      const canvas = canvasPreview.value;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        // Ajusta canvas para caber na largura da tela mantendo proporção
        const maxW = canvas.parentElement?.clientWidth || 900;
        const scale = Math.min(1, maxW / img.width);
        const viewW = Math.round(img.width * scale);
        const viewH = Math.round(img.height * scale);

        canvas.width = viewW;
        canvas.height = viewH;

        // Limpa e desenha fundo
        ctx.clearRect(0, 0, viewW, viewH);
        ctx.drawImage(img, 0, 0, viewW, viewH);

        // Função para desenhar texto com alinhamento em “caixa” (x,y,w)
        const drawTextBox = (text, cfg) => {
          const s = cfg.size * scale;
          ctx.font = `${cfg.size ? s : 36}px ${cfg.font || 'sans-serif'}`;
          ctx.fillStyle = cfg.color || '#000';
          ctx.textBaseline = 'top';

          const x = Math.round(cfg.x * scale);
          const y = Math.round(cfg.y * scale);
          const w = Math.round((cfg.w || img.width) * scale);

          let tx = x;
          if (cfg.align === 'center') tx = x + Math.floor(w / 2);
          if (cfg.align === 'right')  tx = x + w;

          if (cfg.uppercase) text = String(text).toUpperCase();

          // centralização horizontal por medida de texto
          if (cfg.align === 'center') {
            const m = ctx.measureText(text);
            ctx.fillText(text, tx - m.width / 2, y);
          } else if (cfg.align === 'right') {
            const m = ctx.measureText(text);
            ctx.fillText(text, tx - m.width, y);
          } else {
            ctx.fillText(text, tx, y);
          }
        };

        // Textos fictícios para prévia
        const nome  = 'ALUNO EXEMPLO';
        const nivel = `${layoutBinding?.nivel?.prefixo || 'NÍVEL '}II`;
        const data  = 'Brasília, 31 de outubro de 2025';

        drawTextBox(nome,  layoutBinding.nome);
        drawTextBox(nivel, layoutBinding.nivel);
        drawTextBox(data,  layoutBinding.data);
      };

      img.src = certificadoSrc.value; // base do certificado
    }


    // Watcher para validar CNPJ
    watch(() => empresa.cnpj, (newCnpj) => {
      // Remove todos os caracteres não-numéricos
      const cnpjNumeros = newCnpj.replace(/\D/g, '');
      
      // Se ainda não completou os 14 dígitos, limpa a mensagem de erro
      if (cnpjNumeros.length < 14) {
        errors.cnpj = '';
      } else if (cnpjNumeros.length === 14) {
        // Quando tiver 14 dígitos, realiza a validação
        if (!globalUtils.validarCNPJ(newCnpj)) {
          errors.cnpj = 'CNPJ inválido.';
        } else {
          errors.cnpj = '';
        }
      }
    });

    // Watcher para buscar o endereço via CEP e atualizar também estado e município
    watch(() => empresa.cep, async (newCep) => {
      const cepLimpo = newCep ? newCep.replace(/\D/g, '') : '';
      if (cepLimpo.length === 8) {
        try {
          const enderecoData = await globalUtils.buscarEnderecoPorCEP(newCep);
          // Atualiza os campos de endereço, bairro e complemento
          empresa.endereco = enderecoData.endereco || '';
          empresa.bairro = enderecoData.bairro || '';
          empresa.complemento = enderecoData.complemento || '';
          
          // Atualiza estado e município:
          // Procura o estado cujo sigla seja igual ao valor retornado (enderecoData.estado)
          const estadoEncontrado = estados.value.find(e =>
            e.sigla.toUpperCase() === enderecoData.estado.toUpperCase()
          );
          if (estadoEncontrado) {
            empresa.estado_cod = estadoEncontrado.id;
            // Após definir o estado, carrega os municípios para esse estado
            await carregarMunicipios();
            
            // Função auxiliar para normalizar strings (já definida acima)
            const normalizeString = (str) => {
              return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : '';
            };

            // Procura o município cujo nome, normalizado, corresponda ao valor retornado
            const municipioEncontrado = municipios.value.find(m =>
              normalizeString(m.nome) === normalizeString(enderecoData.municipio)
            );
            if (municipioEncontrado) {
              empresa.municipio_cod = municipioEncontrado.id;
            } else {
              empresa.municipio_cod = ''; // Se não encontrar, limpa o campo
            }
          }
        } catch (error) {
          console.error("Erro ao buscar endereço pelo CEP:", error.message);
        }
      }
    });

    watch(() => certificadoSrc.value, () => drawPreview());
    watch(layoutBinding, () => drawPreview(), { deep: true });

    const isFormValid = computed(() => {
      return (

        empresa.razao_social.trim() !== '' &&
        empresa.nome_fantasia.trim() !== '' &&
        empresa.cnpj.trim() !== '' &&
        globalUtils.validarCNPJ(empresa.cnpj) &&
        empresa.telefone2.trim() !== '' &&
        empresa.email.trim() !== '' &&
        empresa.endereco.trim() !== '' &&
        (empresa.numero !== null && empresa.numero.toString().trim() !== '') &&
        empresa.bairro.trim() !== '' &&
        empresa.cep.trim() !== '' &&
        (empresa.municipio_cod !== null && empresa.municipio_cod.toString().trim() !== '') &&
        (empresa.estado_cod !== null && empresa.estado_cod.toString().trim() !== '') &&
        !Object.values(errors).some((error) => error)
      );
    });

    const carregarEstados = async () => {
      try {
        const response = await axios.get(`/localidades/estados`);
        estados.value = response.data;
      } catch (error) {
        console.error('Erro ao carregar estados:', error);
      }
    };

    const carregarMunicipios = async () => {
      try {
        if (!empresa.estado_cod) {
          municipios.value = [];
          return;
        }

        const response = await axios.get(
          `/localidades/municipios/${empresa.estado_cod}`
        );
        municipios.value = response.data;
      } catch (error) {
        console.error('Erro ao carregar municípios:', error);
      }
    };

    const carregarDadosIniciais = async () => {
      try {
        await carregarEstados();

        const token = localStorage.getItem('token');
        if (!token) {
          console.error('Token não encontrado. Faça login novamente.');
          router.push('/login');
          return;
        }

        const response = await axios.get(`/configuracoes/empresa`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = response.data; // conterá logo_bytes / fundo_bytes
        Object.assign(empresa, {
          ...data,
        });

        if (!empresa.certificado_dpi) empresa.certificado_dpi = 300;
        if (empresa.certificado_ativo === null || empresa.certificado_ativo === undefined) {
          empresa.certificado_ativo = true;
        }
        if (!empresa.certificado_modelo_versao) empresa.certificado_modelo_versao = 1;
        
        if (empresa.estado_cod) {
          await carregarMunicipios();
        }
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
      }
    };

    const salvarEmpresa = async () => {
      if (isSubmitting.value) return;        // ← bloqueia duplo clique
      formTouched.value = true;
      // validateForm();

      if (!isFormValid.value) {
        console.error('O formulário contém erros:', errors);
        return;
      }

      try {
        isSubmitting.value = true;
        const formData = new FormData();

        // Adiciona os campos da empresa, exceto os que são arquivos/previews
        for (const [k, v] of Object.entries(empresa)) {
          if ([
            'logomarca',
            'plano_de_fundo',
            'logomarcaPreview',
            'plano_de_fundoPreview',
            'certificadoModeloPreview'
          ].includes(k)) continue;

          formData.append(k, v ?? '');
        }

        // Adiciona o layout em JSON (apenas uma vez, corretamente)
        const layoutToSend = layoutBinding ?? empresa?.certificado_layout ?? {};
        formData.set('certificado_layout', JSON.stringify(layoutToSend));

        // Adiciona os arquivos binários, se existirem
        if (logomarca.value) formData.append('logomarca', logomarca.value);
        if (planoDeFundo.value) formData.append('plano_de_fundo', planoDeFundo.value);
        if (certificadoModelo.value) formData.append('certificado_modelo', certificadoModelo.value);

        const token = localStorage.getItem('token');
        await axios.put(`/configuracoes/empresa`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        });

        // força recarregar endpoints de imagem
        $globalState.assetsVersion = Date.now();
        // limpa previews para voltar a exibir o BYTEA
        delete empresa.logomarcaPreview;
        delete empresa.plano_de_fundoPreview;

        // console.log('Empresa salva com sucesso!');
        router.push('/dashboard');
      } catch (error) {
        console.error('Erro ao salvar a Empresa:', error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const TIPOS_IMAGEM_PERMITIDOS = ['image/jpeg', 'image/png'];

    const TAMANHO_MAXIMO_IMAGENS = {
      logomarca: 2 * 1024 * 1024, // 2 MB
      plano_de_fundo: 5 * 1024 * 1024, // 5 MB
      certificado_modelo: 8 * 1024 * 1024, // 8 MB
    };

    function formatarTamanhoArquivo(bytes) {
      return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    }

    function validarArquivoImagem(campo, arquivo) {
      const tamanhoMaximo = TAMANHO_MAXIMO_IMAGENS[campo] || 2 * 1024 * 1024;

      if (!TIPOS_IMAGEM_PERMITIDOS.includes(arquivo.type)) {
        return {
          valido: false,
          mensagem: 'Arquivo inválido. Envie apenas imagens nos formatos PNG ou JPEG.',
        };
      }

      if (arquivo.size > tamanhoMaximo) {
        return {
          valido: false,
          mensagem: `Arquivo muito grande. O tamanho máximo permitido é ${formatarTamanhoArquivo(tamanhoMaximo)}.`,
        };
      }

      return {
        valido: true,
        mensagem: '',
      };
    }    

    const selecionarArquivo = (campo, event) => {
      const input = event.target;
      const arquivo = input.files?.[0];

      if (!arquivo) return;

      const validacao = validarArquivoImagem(campo, arquivo);

      if (!validacao.valido) {
        input.value = '';

        if (campo === 'logomarca') {
          logomarca.value = null;
          delete empresa.logomarcaPreview;
        }

        if (campo === 'plano_de_fundo') {
          planoDeFundo.value = null;
          delete empresa.plano_de_fundoPreview;
        }

        if (campo === 'certificado_modelo') {
          certificadoModelo.value = null;
          delete empresa.certificadoModeloPreview;
        }

        alert(validacao.mensagem);
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        if (campo === 'logomarca') {
          empresa.logomarcaPreview = e.target.result;
          logomarca.value = arquivo;
        } else if (campo === 'plano_de_fundo') {
          empresa.plano_de_fundoPreview = e.target.result;
          planoDeFundo.value = arquivo;
        }

        if (campo === 'certificado_modelo') {
          empresa.certificadoModeloPreview = e.target.result;
          certificadoModelo.value = arquivo;

          // Detecta as dimensões reais do novo certificado
          const img = new Image();
          img.onload = () => {
            const novaLargura = img.width;
            const novaAltura = img.height;

            // Captura dimensões antigas do layout (para cálculo de escala)
            const antigaLargura = layoutBinding.page?.width_px || novaLargura;
            const antigaAltura = layoutBinding.page?.height_px || novaAltura;

            // Atualiza dimensões do layout
            layoutBinding.page.width_px = novaLargura;
            layoutBinding.page.height_px = novaAltura;

            // Calcula escala proporcional
            const scaleX = novaLargura / antigaLargura;
            const scaleY = novaAltura / antigaAltura;
            const scaleFont = Math.min(scaleX, scaleY); // usa a menor escala para manter proporção legível

            // Reajusta campos de texto (posição, largura e tamanho da fonte)
            ['nome', 'nivel', 'data'].forEach((key) => {
              const campo = layoutBinding[key];
              if (!campo) return;
              campo.x = Math.round((campo.x || 0) * scaleX);
              campo.y = Math.round((campo.y || 0) * scaleY);
              campo.w = Math.round((campo.w || antigaLargura) * scaleX);
              campo.size = Math.round((campo.size || 36) * scaleFont); // 🔹 ajuste do tamanho da fonte
            });

            console.log(
              `[Certificado] Layout realinhado para ${novaLargura}x${novaAltura} (fontScale=${scaleFont.toFixed(2)})`
            );
            drawPreview();
          };

          img.src = e.target.result;
        }
        
      };

      reader.readAsDataURL(arquivo);
    };

    const cancelarFormulario = (event) => {
      const target = event?.target;

      if (target?.type === 'file') {
        return;
      }

      voltar();
    };    

    const voltar = () => {
      router.push('/dashboard');
    };

    onMounted(async () => {
      await carregarDadosIniciais();
      // Sincroniza layoutBinding a partir do banco (ou defaults)
      const layoutFromDb = empresa.certificado_layout && typeof empresa.certificado_layout === 'object'
        ? empresa.certificado_layout
        : null;
      Object.assign(layoutBinding, defaultLayout(), layoutFromDb || {});
      // desenha a primeira prévia
      drawPreview();
    });

    return {
      empresa,
      logoSrc,
      bgSrc,
      logomarca,
      planoDeFundo,
      estados,
      municipios,
      salvarEmpresa,
      carregarEstados,
      carregarMunicipios,
      selecionarArquivo,
      errors,
      formTouched,
      isFormValid,
      isSubmitting,
      voltar,
      cancelarFormulario,
      certificadoSrc,
      layoutBinding,
      canvasPreview,
      isSuperAdmin,
      podeAlterarModulo,
    };
  },
};
</script>

<style scoped>
.empresa-secoes {
  width: 90%; margin: 0 auto; padding: 1rem; background: white;
  border-radius: 6px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); min-width: 0;
}
.empresa-secoes :deep(.base-form) {
  width: 100%; max-width: 100%; margin: 0; padding: 0; box-shadow: none;
}

@media (max-width: 768px) {
  .card.card-body { max-width: 100%; }
  .empresa-secoes { width: 100%; padding: 0; background: transparent; box-shadow: none; }
  .empresa-secoes :deep(.form-group) { max-width: 100%; min-width: 0; }
  .empresa-secoes :deep(input), .empresa-secoes :deep(select), .empresa-secoes :deep(canvas) { max-width: 100%; }
  .empresa-secoes :deep([style*="min-width"]) { min-width: 0 !important; max-width: 100%; }
}
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-label {
  font-weight: normal;
  font-size: 0.8rem;
}
h4 {
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
}
.img-small {
  max-width: 150px;  /* Ajuste para manter a proporção */
  max-height: 150px;
  object-fit: contain; /* Mantém a imagem proporcional dentro do espaço */
}

.file-input-small {
  padding: 0.25rem 0.5rem; /* Reduz o tamanho do input */
  font-size: 0.85rem;
}

</style>
